/**
 * 근로자의 날 수당 계산 근거 — 6 케이스 표 (바텀시트/다이얼로그)
 * 설계문서: required/근로자의날.md §10.4
 */

import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Divider,
} from '@mui/material';
import { AppDialog } from '@/components/ui';
import { LABOR_DAY_CASES } from '../../utils/laborDayAllowance';

interface LaborDayInfoSheetProps {
  open: boolean;
  onClose: () => void;
}

const LaborDayInfoSheet: React.FC<LaborDayInfoSheetProps> = ({ open, onClose }) => (
  <AppDialog
    open={open}
    title="근로자의 날 수당 계산 근거"
    onClose={onClose}
    maxWidth="md"
    actions={<Button variant="text" onClick={onClose}>닫기</Button>}
  >
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        2026 최저시급 10,320원 · 8시간 기준
      </Typography>
      <Box sx={{ overflowX: 'auto' }}>
        <Table size="small" sx={{ minWidth: 640 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: 'grey.100' }}>
              <TableCell sx={{ fontWeight: 600 }}>구분</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>고용</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>계산식</TableCell>
              <TableCell sx={{ fontWeight: 600, textAlign: 'right' }}>금액</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>비고</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {LABOR_DAY_CASES.map((row, i) => (
              <TableRow key={i} hover>
                <TableCell>{row[0]}</TableCell>
                <TableCell>{row[1]}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap', fontFamily: 'var(--font-mono)', fontSize: '0.85rem' }}>
                  {row[2]}
                </TableCell>
                <TableCell sx={{ textAlign: 'right', fontWeight: 600, whiteSpace: 'nowrap' }}>
                  {row[3]}
                </TableCell>
                <TableCell>{row[4]}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
      <Divider sx={{ my: 2 }} />
      <Box
        sx={{
          p: 1.5,
          borderRadius: 1,
          backgroundColor: 'primary.50',
          border: '1px solid',
          borderColor: 'primary.200',
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          노동절 수당 = 유급분 + 실근무분 + 가산분(5인 이상)
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
          * 시급제는 결근해도 8시간분 유급. 5인 이상은 실근무분의 50% 가산.
        </Typography>
      </Box>
  </AppDialog>
);

export default LaborDayInfoSheet;
